import React, { useEffect, useState } from "react";
import RadioButtonGroup from "../../UI_Design/FormComponents/RadioAndLabel/RadioButtonGroup";
import TextField from "../OnbordingForm/TabsAndContent/textField";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ABUploadAdd from "../Common/ABUploadAdd";
import { getForm16CheckData, saveForm16Data } from "../../Actions/form16Actions";
import { validatePAN } from "../../Helper/common";
import Loader from "../Common/loader";

const FormFields = (props) => {
  const {
    fields,
    caseCheckId,
    documentVisibility,
    index,
    key,
    active,
    requiredDocs,
    uploadedFilesCount,
    documnetMandatory,
    uploadRecord,
    setActiveTab,
    handleTabClick,
    changeTab
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [allFields, setAllFields] = useState({});
  const [savePayload, setSavePayload] = useState({});
  const [isForm, setIsForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [uploadedFilesCount, setUploadedFilesCount] = useState({});


  console.log(fields, "sss");

  useEffect(() => {
    setAllFields(fields);

    Object.values(fields).map((item) => {
      // console.log(value);
      setSavePayload((prev) => ({
        ...prev,
        [item?.id]: item?.field_value,
      }));
    });

    if(fields?.form_16_available?.field_value == 'Yes' || fields?.form_16_available?.field_value == 'yes' || fields?.form_16_available?.field_value == '1'){
      setIsForm(true);
    }else if(fields?.form_16_available?.field_value == 'No' || fields?.form_16_available?.field_value == 'no' || fields?.form_16_available?.field_value == '0'){
      setIsForm(false);
    }else if(fields?.form_16_available?.field_value == ""){
      setIsForm(false);
    }
  }, [fields, index]);



  const handleRadioButtonChange = (index, id, selectedOption, option) => {
    // setHasCourtRecord(index === 0); // Assuming "Yes" is the first option (index 0)
    setIsForm(index === 0);

    let flag;
    if(option == 'Yes' || option == 'yes'){
      // flag = '1'
      flag = "Yes"
    }else{
      // flag = '0'
      flag = 'No'
    }

    setSavePayload((prev) => ({
      ...prev,
      [id]: flag,
    }));
  };

  const handleInputChange = (val) => {
    var cols = document.getElementById(val[0].err_id);
    cols.innerHTML = "";

    setSavePayload((prev) => ({
      ...prev,
      [val[0]?.id]: val[0]?.value,
    }));

    // if(name[0]?.name == 'address'){
    //     setAddress(name[0]?.value);
    // }

    // if(name[0]?.name == 'CNR'){
    //     setCnrNumbers(name[0]?.value);
    // }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let err = formValidation();

    if(err == true){
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }else{
    setIsLoading(true);
    let recordData = {};
    let saveFields = { ...savePayload };

    const obj = {
      group: "form_16",
      thischeckid: 271,
      ...saveFields,
    };

    if(!isForm){
      let panID = allFields?.employment_pan_number?.id;
      let tanId = allFields?.employment_tan_number?.id;
      let certId = allFields?.employment_certificate_no?.id;

      obj[panID] = '';
      obj[tanId] = '';
      obj[certId] = '';

    }

    recordData.check_data = {
      [caseCheckId]: { ...obj },
    };
    // recordData.check_data = { [formData?.declarationFormFields?.case_check_id]: obj };
    recordData.case_check_id = caseCheckId;

    console.log(recordData);
    dispatch(saveForm16Data(recordData, saveCallback));
    }
  };

  const saveCallback = (data) => {
    const group = data.group ? data.group.group_id : "";
    const hasNextCheck = data.nextCheck != "" ? true : false;
    const reference = data.reference_number;

    if (group == "profile_preview" || data.group == "profile_preview") {
      navigate(`/case-initiation/profile-preview/${reference}`);
    } else if (data?.group == 23) {
      // navigate(`/case-initiation/check-detail/${reference}/${group}`);
      // setActiveTab(index+1);
      // handleTabClick(index+1);
      dispatch(getForm16CheckData(props?.getDataCallback));
      changeTab(index+1);
    } else if (typeof group != "undefined" && group != "") {
      navigate(`/case-initiation/check-detail/${reference}/${group}`);
    }

    setIsLoading(false);
  };

  const formValidation = () => {
    let isError = false;

    // Resetting all errors first
    const errorElements = document.getElementsByClassName("err text-danger");
    for (let i = 0; i < errorElements.length; i++) {
      errorElements[i].innerHTML = "";
    }

    if(isForm){
      // check all validations
      const pan = allFields?.employment_pan_number;
      if (pan?.is_mandatory == 1) {
        isError = validateField(pan);
        if(!isError){
          let validPan = validatePAN(savePayload?.[allFields?.employment_pan_number?.id]);
          if(!validPan){
            const fieldId = pan?.id;
            const elementErrorId = `err-${fieldId}-${index}`;
            const errorElement = document.getElementById([elementErrorId]);
            if (errorElement) {
              errorElement.innerHTML = "Please enter a valid PAN Number.";
              return true;
            }
          }
        }
      }

      const tan = allFields?.employment_tan_number;
      if(tan?.is_mandatory == 1){
        isError = validateField(tan);
      }

      const certNo = allFields?.employment_certificate_no;
      if(certNo?.is_mandatory == 1){
        isError = validateField(certNo);
      }

      let value = requiredDocs?.[0];

      let count = uploadedFilesCount[parseInt(index)][
        value.id
      ]

      // const upload = allFields?.employment_pan_number;

      if(count < 1){
        const elementErrorId = `err_document_${value.id}_count_${caseCheckId}`
        const errorElement = document.getElementById([elementErrorId]);
        if (errorElement) {
          errorElement.innerHTML = "This field is required.";
          isError = true;
        }
      }

    }


    // Check if the court record field is required
    // if (!hasCourtRecord == true) {
    //   const declarationAddress = fields?.declaration_address;
    //   if (declarationAddress?.is_mandatory == 1) {
    //     isError = validateField(declarationAddress);
    //   }
    // } else {
    //   const declarationCnrNumber = fields?.declaration_cnr_number;
    //   if (declarationCnrNumber?.is_mandatory == 1) {
    //     isError = validateField(declarationCnrNumber);
    //   }
    // }

    // Return true if there are any errors, false otherwise
    return isError;
  };

  // Reusable function to handle field validation
  const validateField = (field, errorMessage = "This field is required.") => {
    const fieldId = field?.id;
    const elementErrorId = `err-${fieldId}-${index}`;
    // let fieldValue
    const fieldValue = savePayload?.[fieldId];

    if (
      fieldValue === undefined ||
      fieldValue === null ||
      fieldValue.trim() === ""
    ) {
      const errorElement = document.getElementById([elementErrorId]);
      if (errorElement) {
        errorElement.innerHTML = errorMessage;
        //   isError = true;
        return true;
      }
    }
  };

  const reRenderAgain = () => {
    props.reRenderAgain();
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  // const getUploadedFilesCount = (checksDetails) => {
  //   let uploadedFilesCount = {};
  //   for (let i in checksDetails) {
  //     let obj = {};
  //     for (let j in checksDetails[i].required_documents) {
  //       let count = 0;
  //       for (let k in checksDetails[i].uploaded_documents) {
  //         if (
  //           checksDetails[i].uploaded_documents[k].document_id ==
  //           checksDetails[i].required_documents[j].id
  //         ) {
  //           count++;
  //         }
  //       }
  //       obj[`${checksDetails[i].required_documents[j].id}`] = count;
  //     }
  //     uploadedFilesCount[i] = obj;
  //   }
  //   setUploadedFilesCount(uploadedFilesCount);
  // };

  // const getDocumentIdMandatory = (checksDetails) => {
  //   let uploadedFilesCount = {};
  //   for (let i in checksDetails) {
  //     let obj = {};
  //     for (let j in checksDetails[i].required_documents) {
  //       obj[
  //         `${checksDetails[i].required_documents[j].id}`
  //       ] = `${checksDetails[i].required_documents[j].is_mandatory}`;
  //     }
  //     uploadedFilesCount[i] = obj;
  //   }

  //   // alert(JSON.stringify(uploadedFilesCount));
  //   // setDocumnetMandatory(uploadedFilesCount);
  // };

  // console.log(allFields?.form_16_available?.field_value == '1' ? 'Yes' : allFields?.form_16_available?.field_value != '0' ? '' : 'No', 'filessss', allFields?.form_16_available?.field_value )

  return (
    <>
      {isLoading && <Loader />}
      {allFields?.form_16_available && (
        <div className="my-3 pb-1">
          <p className="m-0 my-2" style={{fontWeight: 600}}>{`${allFields?.form_16_available?.label} ${allFields?.employment_assessment_year?.field_value} ?`}</p>
          <RadioButtonGroup
            options={Object.values(
              allFields?.form_16_available?.getFieldDisplay?.optionArray
                ?.options
            )}
            id={allFields?.form_16_available?.id}
            onChange={handleRadioButtonChange}
            value={allFields?.form_16_available?.field_value == 'Yes' ? 'Yes' : allFields?.form_16_available?.field_value == 'No' ? 'No' : ''}
            errId={`err-${allFields?.form_16_available?.id}`}
            name={'form16'}
            />
        </div>
      )}
      

      <div className="row">
        {isForm && allFields?.employment_pan_number && (
            <TextField
              label={`${allFields?.employment_pan_number?.label}`}
              id={allFields?.employment_pan_number?.id}
              errId={`err-${allFields?.employment_pan_number?.id}-${index}`}
              name="address"
              value={allFields?.employment_pan_number?.field_value}
              inputText={handleInputChange}
              placeholder="Enter your address"
              isRequired={allFields?.employment_pan_number?.is_mandatory}
              divClass={'col-sm-12 col-md-6 col-lg-4'}
              // divClass="col-lg-4 col-md-6 col-sm-12"

            />
        )}

        {isForm && allFields?.employment_tan_number && (
            <TextField
              label={`${allFields?.employment_tan_number?.label}`}
              id={allFields?.employment_tan_number?.id}
              errId={`err-${allFields?.employment_tan_number?.id}-${index}`}
              name="address"
              value={allFields?.employment_tan_number?.field_value}
              inputText={handleInputChange}
              placeholder="Enter your address"
              isRequired={allFields?.employment_tan_number?.is_mandatory}
              divClass={'col-sm-12 col-md-6 col-lg-4'}
            />
        )}
      </div>

      <div className="row">
        {isForm && allFields?.employment_assessment_year && (
            <TextField
              label={`${allFields?.employment_assessment_year?.label}`}
              id={allFields?.employment_assessment_year?.id}
              errId={`err-${allFields?.employment_assessment_year?.id}-${index}`}
              name="address"
              value={allFields?.employment_assessment_year?.field_value}
              inputText={handleInputChange}
              placeholder=""
              isRequired={allFields?.employment_assessment_year?.is_mandatory}
              isDisabled={true}
              divClass={'col-sm-12 col-md-6 col-lg-4'}
            />
        )}

        {isForm && allFields?.employment_certificate_no && (
            <TextField
              label={`${allFields?.employment_certificate_no?.label}`}
              id={allFields?.employment_certificate_no?.id}
              errId={`err-${allFields?.employment_certificate_no?.id}-${index}`}
              name="address"
              value={allFields?.employment_certificate_no?.field_value}
              inputText={handleInputChange}
              placeholder=""
              isRequired={allFields?.employment_certificate_no?.is_mandatory}
              divClass={'col-sm-12 col-md-6 col-lg-4'}
            />
        )}

      </div>
        {isForm &&
          requiredDocs &&
          Object.entries(requiredDocs).map(([key, value]) => {
            if (key == 0) {

              // console.log(uploadedFilesCount[parseInt(index )][
              //   value.id
              // ], 'filesss')
              return (
                <>
                  {/* {address?.clientId == 387715 && (
                                  <p style={{ color: "red" }}>
                                    Acceptable document types - Driving License
                                    ,Voter card or Passport
                                  </p>
                                )} */}
                  <div className="">

                  <ABUploadAdd
                    name={value.id}
                    id={value.id}
                    title={value.document_name}
                    key={`${caseCheckId}-1`}
                    record={{
                      caseCheckId:
                        caseCheckId,
                      docId: value.id,
                    }}
                    uploadCallback={props?.uploadCallback}
                    // record={{
                    //   caseCheckId:
                    //     active !== null && active !== undefined
                    //       ? active
                    //       : caseCheckId,
                    //   docId: value.id,
                    // }}
                    totalCount={
                      uploadedFilesCount[parseInt(index )] &&
                      uploadedFilesCount[parseInt(index )][
                        value.id
                      ]
                        ? uploadedFilesCount[parseInt(index )][
                            value.id
                          ]
                        : 0
                    }
                    // errorCheck={errorCheck}
                    isRequired={
                      documnetMandatory[parseInt(index )][
                        value.id
                      ]
                    }
                    // isRequired={value?.is_mandatory}
                    // getCount={doc371Count}
                    reRenderAgain={reRenderAgain}
                  />

                  </div>


                  <input
                    type="hidden"
                    name={`document_${value.id}_count_${caseCheckId}`}
                    id={`document_${value.id}_count_${caseCheckId}`}
                    value={
                      uploadedFilesCount[parseInt(index )] &&
                      uploadedFilesCount[parseInt(index )][
                        value.id
                      ]
                        ? uploadedFilesCount[parseInt(index )][
                            value.id
                          ]
                        : 0
                    }
                    data-mandatory={
                      documnetMandatory[parseInt(index )][
                        value.id
                      ]
                    }
                  />

                  <p
                    className="err text-danger"
                    id={`err_document_${value.id}_count_${caseCheckId}`}
                  ></p>
                </>
              );
            }
          })}

        <button
          onClick={(e) => handleSubmit(e)}
          // disabled={savePayload[allFields?.form_16_available?.id] == ""}
          disabled={allFields?.form_16_available?.field_value == '' &&  savePayload?.[allFields?.form_16_available?.id] == '' ? true : false}
          className="btn btn-primary mt-2"
        >
          Submit
        </button>
    </>
  );
};

export default FormFields;
